// Vendors
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
// Enums
import { StorageLocalEnum } from '@openbank/ziniaweb-ui-core-models';
// Handlers
import { SessionExpireHandlers } from '../handlers/session-expire.handlers';
// Types
import { SessionExpireHookType } from './types/session-expire.hook.type';

const useSessionExpireHook = (): SessionExpireHookType => {
  const { formatMessage } = useIntl();
  const timeoutRef = useRef(0);
  const [sessionWarningMessage, setSessionWarningMessage] = useState('');
  const [errorTimeout, setErrorTimeout] = useState(false);
  const cookieTimeout = localStorage.getItem(StorageLocalEnum.SESSION_EXPIRES_AT);

  const { handleCloseWarningMessage, handleStartSessionTimeout } = SessionExpireHandlers({
    formatMessage,
    timeoutRef,
    setErrorTimeout,
    setSessionWarningMessage,
  });

  useEffect(() => {
    const finalizer = handleStartSessionTimeout();
    return () => {
      finalizer?.();
    };
  }, [cookieTimeout]);

  return {
    errorTimeout,
    handleCloseWarningMessage,
    sessionWarningMessage,
    openSnackbar: sessionWarningMessage !== '',
  };
};

export { useSessionExpireHook };
